import React, { useEffect, useState, useCallback, useRef, memo } from "react";

const Index = (props: any) => {
  const { horizontal, vertical } = props;
  const videoRef = useRef<any>(null);
  
  const openWebCam = async () => {
    videoRef.current.srcObject = await navigator.mediaDevices.getUserMedia({audio: true, video: true});
  };

  useEffect(() => {
    openWebCam();
  }, []);

  return (
    <React.Fragment>
      <div
        className="h-100 w-100"        
        style={{ transform: `scaleY(${ vertical }) scaleX(${ horizontal })` }}
      >
        <video
          ref={videoRef}
          className="webcam-box"
          autoPlay
          muted
        >
        </video>
      </div>
    </React.Fragment>
  );
};

export default memo(Index);